import { render, staticRenderFns } from "./Consult.vue?vue&type=template&id=489366f8&scoped=true"
import script from "./Consult.vue?vue&type=script&lang=ts"
export * from "./Consult.vue?vue&type=script&lang=ts"
import style0 from "./Consult.vue?vue&type=style&index=0&id=489366f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489366f8",
  null
  
)

export default component.exports